module.exports = __webpack_public_path__ + "static/media/Reserve_Active.aaa8d203.png";